import { render, staticRenderFns } from "./PayPalButton.vue?vue&type=template&id=90587ff0&scoped=true&"
import script from "./PayPalButton.vue?vue&type=script&lang=js&"
export * from "./PayPalButton.vue?vue&type=script&lang=js&"
import style0 from "./PayPalButton.vue?vue&type=style&index=0&id=90587ff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90587ff0",
  null
  
)

export default component.exports